import authClient from "services/httpClient/authClient";
import { CompleteLoginPayload, EncryptionInfoResponse, LoginResponse, MfaActivationCodePayload, MfaActivationCodeResponse, RecoverPasswordPayload, RecoverPasswordResponse, ResendMfaCodePayload, ResendMfaCodeResponse, ResetPasswordPayload, ResetPasswordResponse, UserLoginPayload } from "./models";

export const getEncryptionInfo = () => {
  return authClient.get<EncryptionInfoResponse>("/api/Account/encryption-info");
};

export const login = (payload: UserLoginPayload) => {
  return authClient.post<LoginResponse>("/api/Account/login", payload);
};

export const completeLogin = (payload: CompleteLoginPayload) => {
  return authClient.post<LoginResponse>("/api/Account/complete-login", payload);
};

export const getMfaActivationCode = (payload: MfaActivationCodePayload) => {
  return authClient.post<MfaActivationCodeResponse>("/api/Account/mfa-activation-code", payload);
};

export const resendMfaCode = (payload: ResendMfaCodePayload) => {
  return authClient.post<ResendMfaCodeResponse>("/api/Account/resend-mfa-code", payload);
};

export const recoverPassword = (payload: RecoverPasswordPayload) => {
  return authClient.post<RecoverPasswordResponse>("/api/Account/recover-password", payload);
}

export const resetPassword = (payload: ResetPasswordPayload) => {
  return authClient.post<ResetPasswordResponse>("/api/Account/reset-password", payload);
}

export const logOutUser =()=>{
  return authClient.post("/api/Account/logout")
}
